import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {formatDate} from '@angular/common';
import {Constants} from "./constants";

export class Utilities {
    static handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }

    static mapToObject(map) {
        return [...map.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
    }

    static objectToMap<T>(object): Map<string, T> {
        return new Map<string, T>(Object.entries<T>(object));
    }

    static getTranslateUrl() {
        return environment.translateUrl;
    }

    static getServiceUrl() {
        return environment.serviceUrl;
    }

    static dateToBackendString(date: Date) {
        return formatDate(date, 'yyyy-MM-dd', 'en-US');
    }


    static onlyTimeToBackendString(date: Date) {
        return formatDate(date, 'HH:mm:ss', 'en-US');
    }

    static dateToBackendDateTimeString(date: Date, replace?: boolean) {
        return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US').replace(' ', replace ? 'T' : ' ');
    }

    static arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    static timeToBackendString(id: string) {
        console.log(id);
        const time = id.split('-');

        return time[0].trim() + ':00';
    }

    static addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    static minusDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() - days);
        return result;
    }

    static addMinutesToDate(date: Date, minutes): Date {
        let timeStamp = date.getTime() + (minutes * 60000);
        return new Date(timeStamp);
    }

    static addHoursToDate(date: Date, hours): Date {
        let timeStamp = date.getTime() + (hours * 1000*60*60);
        return new Date(timeStamp);
    }

    static isProduction() {
        return environment.production;
    }

    static findMin(array: number[]): number {
        return Math.min(...array)
    }

    static findMax(array: number[]): number {
        return Math.max(...array)
    }


    static sortByCreatedAt() {
        return (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    }

    static validateEmail(email: string): boolean {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static createMultiSelectElements(entityList: any[], idField: string, nameField: string): any[] {
        let result = [];
        entityList.forEach(entity => {
            result.push(Utilities.createMultiSelectElement(entity, idField, nameField));
        });
        return result;
    }

    static createMultiSelectElement(entity: any[], idField: string, nameField: string) {
        return {
            id: entity[idField],
            itemName: entity[nameField],
            entity: entity
        };
    }

    static createModalConfig(initialState, cssClass?:string): any {
        return {
            class:(cssClass?cssClass:'modal-xl'),
            initialState: initialState,
            animated: true,
            backdrop: 'static',
            keyboard: false,
        };
    }

    static dateToPath(date: Date) {
        return formatDate(date, 'yyyy_MM_dd_HH_mm_ss', 'en-US')
    }
    static createHourSet(value, d:Date, startHour:number) {
        let hoursArray = [];
        d.setHours(startHour,0,0,0);
        const date = d.getDate();
        while ( date == d.getDate() ) {
            hoursArray.push( ( "0" + d.getHours() ).slice(-2) + ":" + ( "0" + d.getMinutes() ).slice(-2)+":00");
            d.setMinutes( d.getMinutes() + value);
        }
        return hoursArray;
    }

}
